
import { computed, ComputedRef, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { convertCurrency } from "@/services/ConvertCurrency"
import { formatValue } from "@/services/FormatValue"
import { IonHeader, IonToolbar, IonSkeletonText } from '@ionic/vue'

import useCurrency from '@/hooks/useCurrency'
import useBalance from '@/hooks/useBalance'
import usePrivacyMode from '@/hooks/usePrivacyMode'
import { Haptics, ImpactStyle } from '@capacitor/haptics'

export default defineComponent({
    components: { IonHeader, IonToolbar, IonSkeletonText },
    setup() {
        const store = useStore()
        const router = useRouter()
        const isLoading: ComputedRef<boolean> = computed(() => store.getters.isLoading)
        const { preferredCurrency, currencyRate, baseCurrencyRate } = useCurrency()

        const balance = useBalance()
        const { PRIVACY_MASK, isPrivacyModeActive, handlePrivacyMode } = usePrivacyMode()

        const hapticsImpactLight = async () => {
            await Haptics.impact({ style: ImpactStyle.Light });
        };

        const handleLongPress = () => {
            handlePrivacyMode()
            hapticsImpactLight()
        }

        return { isLoading, preferredCurrency, router, formatValue, convertCurrency, currencyRate, baseCurrencyRate, balance, PRIVACY_MASK, isPrivacyModeActive, handleLongPress }
    },
})
